import DaisyBaseService from './../../../services/DaisyBaseService';

/**
 * this is the location service to handle the communication with the daisy backend
 **/
export default class LocationService extends DaisyBaseService {
	/**
	 * define required services here, think of the defined services inside the constructor of the superclass
	 * @param {function} - $injector to inject all services
	 **/
	constructor($injector) {
		super($injector);
		this.baseUrl += 'Transportauftraege';
		this.$storage = $injector.get('$localStorage');
		this.$sessionStorage = $injector.get('$sessionStorage');
	}
	
	/**
	 * get all locations
	 * @param {boolean} whether or not return locations from localStorage
	 * @return {promise}
	 **/
	getLocations(cache = false) {
		if(cache) {
			return new Promise((resolve, reject) => {
				resolve(this.$storage.locations);
			});
		}

		let functionUrl = '/ladeStandorte';
		let data = {
			"request": {
			    "RTTI_DUMMY": "",
				"PLANT_ID": ("auth" in this.$sessionStorage)?parseInt(this.$sessionStorage.auth.PLANT_ID):0
			}
		};

		return this.doPost(functionUrl, data)
			.then(response => {
				this.$storage.locations = response;
				return response;
			});
	}

	/**
	 * get location
	 * @param {number} id - location id
	 **/
	getLocation(id) {
		let functionUrl = '/ladeStandort';
		let data = {id: id};

		return this.doPost(functionUrl, data);
	}

	getLocationTree(id){
        let functionUrl = '/LadeLgrOrtBaum';
        let data = {
            "request": {
                "RTTI_DUMMY": "",
                "id": id
            }
        };

        return this.doPost(functionUrl, data);
	}

}
